module.exports = __webpack_public_path__ + "img/fy1.4350742c.png";